import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpService } from '@app/@core/services/http.service';
import { DynamicTabPageConfig } from '@app/pages/dynamic-tab-page/@core/dynamic-tab-page-url.config';
import { NgxfUploaderService } from 'ngxf-uploader';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DynamicTabPageService {
  private isPageDesign = new BehaviorSubject<boolean>(false);
  observePage = this.isPageDesign.asObservable();
  constructor(private uploadService: NgxfUploaderService, private httpService: HttpService) {
     // This is intentional
  }

  getActivePage(tabPageId: any, permission?: boolean) {
    return this.httpService.get(
      `${DynamicTabPageConfig.EndPoint.Page.getActivePage.replace('{id}', tabPageId)}${
        permission ? '?applyPermissions=true' : ''
      }`
    );
  }

  getDynamicPage(pageId: any) {
    return this.httpService.get(`${DynamicTabPageConfig.EndPoint.Page.getPage}/${pageId}`);
  }

  getPageById(pageId: any) {
    return this.httpService.get(DynamicTabPageConfig.EndPoint.Page.getPageById.replace('{id}', pageId));
  }

  getListBySourceId(sourceId: any) {
    return this.httpService.get(DynamicTabPageConfig.EndPoint.Narrative.getIncidentListById.replace('{id}', sourceId));
  }

  getResponseByPageId(responseId: any, pageId: any) {
    return this.httpService.get(
      DynamicTabPageConfig.EndPoint.Page.getResponseByPageId
        .replace('{responseId}', responseId)
        .replace('{pageId}', pageId)
    );
  }

  createFormResponse(id: any, requestData) {
    return this.httpService.post(
      id
        ? DynamicTabPageConfig.EndPoint.Page.updateFormResponse
        : DynamicTabPageConfig.EndPoint.Page.createFormResponse,
      requestData
    );
  }

  createUserSurvey(history, Id: any) {
    return this.httpService.post(
      DynamicTabPageConfig.EndPoint.Notification.createSurveyConfig
        .replace('{id}', history?.state?.usersurveyid)
        .replace('{status}', 'Completed')
        .replace('{pagedataid}', Id),
      {}
    );
  }

  updateFormResponse(id: any, requestData: any) {
    return this.httpService.patch(`${DynamicTabPageConfig.EndPoint.Page.patchFormResponse}/${id}`, requestData);
  }

  exportReport(data: any) {
    return this.httpService.post(DynamicTabPageConfig.EndPoint.Finance.exportDocument, data);
  }

  uploadFile(file: any) {
    return this.uploadService.upload({
      url: this.httpService.baseUrl + '/' + DynamicTabPageConfig.EndPoint.Finance.uploadDocument,
      headers: new HttpHeaders()
        .set('ctype', 'file')
        .set('uniqueid', '6b61ac1e-221a-495c-957b-ad85f65be25a')
        .set('role', 'role=CP_PUBLIC'),
      files: file,
      process: true
    });
  }

  getUniqueId(api: string) {
    return this.httpService.get(DynamicTabPageConfig.EndPoint.Finance.getUniqueId + api);
  }

  changePage(page) {
    this.isPageDesign.next(page);
  }

  createFormResponseAttachment(data) {
    return this.httpService.post(DynamicTabPageConfig.EndPoint.Attachments.createAttachment, data);
  }

  getYouthSummaryDetails(data) {
    return this.httpService.post(`${DynamicTabPageConfig.EndPoint.youthSummary.getDetails}`, data);
  }

  getAlertCount(youthId: any) {
    return this.httpService.get(`${DynamicTabPageConfig.EndPoint.youthSummary.getAlertCount}/${youthId}`);
  }

  getRiskValue(youthId: any) {
    return this.httpService.get(`${DynamicTabPageConfig.EndPoint.youthSummary.getRiskValue}/${youthId}`);
  }
}
